import { openBlock as n, createElementBlock as t, mergeProps as l, createElementVNode as r } from "vue";
import { _ as i } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const s = {};
function c(o, e) {
  return n(), t("svg", l(o.$attrs, {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    r("g", { id: "Minus Circle Filled" }, [
      r("path", {
        id: "Icon",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16ZM21 17C21.5523 17 22 16.5523 22 16C22 15.4477 21.5523 15 21 15H11C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H21Z"
      })
    ], -1)
  ]), 16);
}
const C = /* @__PURE__ */ i(s, [["render", c]]);
export {
  C as default
};
